/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecurityFingerprintIcon16Light } from './SecurityFingerprintIcon16Light';
import { SecurityFingerprintIcon16Regular } from './SecurityFingerprintIcon16Regular';
import { SecurityFingerprintIcon16Solid } from './SecurityFingerprintIcon16Solid';
import { SecurityFingerprintIcon20Light } from './SecurityFingerprintIcon20Light';
import { SecurityFingerprintIcon20Regular } from './SecurityFingerprintIcon20Regular';
import { SecurityFingerprintIcon20Solid } from './SecurityFingerprintIcon20Solid';
import { SecurityFingerprintIcon24Regular } from './SecurityFingerprintIcon24Regular';
import { SecurityFingerprintIcon24Solid } from './SecurityFingerprintIcon24Solid';
import { SecurityFingerprintIcon32Regular } from './SecurityFingerprintIcon32Regular';
import { SecurityFingerprintIcon64Regular } from './SecurityFingerprintIcon64Regular';
var sizes = {
    16: {
        light: SecurityFingerprintIcon16Light,
        regular: SecurityFingerprintIcon16Regular,
        solid: SecurityFingerprintIcon16Solid,
    },
    20: {
        light: SecurityFingerprintIcon20Light,
        regular: SecurityFingerprintIcon20Regular,
        solid: SecurityFingerprintIcon20Solid,
    },
    24: {
        regular: SecurityFingerprintIcon24Regular,
        solid: SecurityFingerprintIcon24Solid,
    },
    32: {
        regular: SecurityFingerprintIcon32Regular,
    },
    64: {
        regular: SecurityFingerprintIcon64Regular,
    },
};
export var SecurityFingerprintIcon = forwardRef('SecurityFingerprintIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
